import { Section } from '@shared/components/Section';
import { marcos, ressalva, fonteDaConta, remateDaConta } from '@curso/content/origem';

/**
 * Responde: de onde vem essa ideia.
 *
 * A aviação entra como história, não como modelo a copiar. Os três marcos
 * montam a pergunta e a ressalva responde: a origem se afirma, a cópia se
 * evita.
 *
 * Os números vêm de 02-referencias/dados-verificados.md, todos conferidos na
 * publicação original. Desde 19/10 a fonte do terceiro marco aparece na
 * página: num público de qualidade e gestão de riscos, número sem fonte vira
 * objeção em vez de argumento.
 */
export function DeOndeVem() {
  return (
    <>
      <Section
        id="de-onde-vem"
        rotulo="De onde vem"
        titulo="Da aviação à saúde: a origem do CRM"
      >
        <p className="prosa mb-8">
          O CRM nasceu quando organizações de alto risco perceberam que excelência técnica,
          sozinha, não era suficiente para evitar eventos graves.
        </p>

        <ol className="border-t border-linha">
          {marcos.map((marco) => (
            <li key={marco.ano} className="border-b border-linha py-6">
              <div className="grade-marco">
                <span className="rotulo tabular-nums">{marco.ano}</span>
                <div>
                  <h3 className="display-item">{marco.titulo}</h3>
                  <p className="mt-2 text-apoio leading-relaxed text-pretty text-tinta-suave">
                    {marco.texto}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <p className="prosa mt-8">{remateDaConta}</p>
        <p className="mt-5 border-l-2 border-linha-forte pl-4 text-miudo leading-relaxed text-tinta-fraca">
          {fonteDaConta}
        </p>
      </Section>

      <Section id="nao-e-copia" rotulo="A tradução" titulo={ressalva.titulo}>
        <p className="prosa">{ressalva.texto}</p>
        <p className="prosa mt-5 text-tinta">{ressalva.remate}</p>
      </Section>
    </>
  );
}
